import { FC } from 'react';

import IMask from 'imask';
import styled from 'styled-components';

import { SeturInputProps } from '@components/Input';
import { SeturInputStyles } from '@components/Input/variants/Default/styled';
import { IOS_INPUT_ZOOM_GUARD } from '@components/Input/variants/mixins';

import { FormattedInputWrapper } from './common';

const YEAR = new Date().getFullYear();

const dateBlocks = ({
  maxYear,
  minYear,
}: {
  maxYear?: number;
  minYear?: number;
}) => ({
  YYYY: {
    mask: IMask.MaskedRange,
    from: minYear || 1,
    to: maxYear || YEAR,
  },
  MM: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
  },
  DD: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 31,
  },
});

const Input = styled.input.attrs({ inputMode: 'numeric' })<SeturInputProps>`
  &&& {
    ${({ theme, $size, disabled, hasError }) =>
      SeturInputStyles(theme.palette, $size, disabled, hasError)}
    ${IOS_INPUT_ZOOM_GUARD}
  }
`;

export type IDateInput = {
  date?: string;
  placeHolder?: string;
  maxYear?: number;
  minYear?: number;
  contact?: boolean;
} & SeturInputProps;

export const DateInput: FC<IDateInput> = ({
  id = 'birthDate',
  label = 'Doğum Tarihi',
  placeholder = 'Giriniz',
  contact = false,
  maxYear,
  minYear,
  ...rest
}) => {
  return (
    <FormattedInputWrapper
      mask='DD/MM/YYYY'
      blocks={dateBlocks({ maxYear, minYear })}
      unmask={false}
      name='expDate'
      id={id}
      label={contact ? undefined : label}
      placeholder={placeholder}
      type='text'
      InputComponent={Input}
      forwardValue={rest.value}
      {...rest}
    />
  );
};

export default DateInput;
